import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useTopOfPageContextStore } from "@faire/retailer-visitor-shared/stores/ui/TopOfPageContextStore";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useCallback, useEffect, useMemo, useRef } from "react";
export var useResizeRefCallback = function() {
    var _useTopOfPageContextStore = _sliced_to_array(useTopOfPageContextStore([]), 2), _ = _useTopOfPageContextStore[0], setStore = _useTopOfPageContextStore[1];
    var contentRef = useRef(null);
    var resizeObserverRef = useRef(undefined);
    var setHeaderHeight = useCallback(function(height) {
        if (height !== undefined) {
            setStore({
                height: height
            });
        }
    }, [
        setStore
    ]);
    var handleResize = useCallback(function() {
        var _contentRef_current;
        var _contentRef_current_clientHeight;
        setHeaderHeight((_contentRef_current_clientHeight = (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.clientHeight) !== null && _contentRef_current_clientHeight !== void 0 ? _contentRef_current_clientHeight : 0);
    }, [
        setHeaderHeight
    ]);
    var debouncedHandleResize = useMemo(function() {
        return debounceIfPossible(function() {
            handleResize();
        }, 500);
    }, [
        handleResize
    ]);
    useEffect(function() {
        var _window = getWindowOrThrow();
        _window.addEventListener("resize", debouncedHandleResize);
        return function() {
            _window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [
        debouncedHandleResize
    ]);
    useEffect(function() {
        return function() {
            var _resizeObserverRef_current;
            if (contentRef.current) {
                var _resizeObserverRef_current1;
                (_resizeObserverRef_current1 = resizeObserverRef.current) === null || _resizeObserverRef_current1 === void 0 ? void 0 : _resizeObserverRef_current1.unobserve(contentRef.current);
            }
            (_resizeObserverRef_current = resizeObserverRef.current) === null || _resizeObserverRef_current === void 0 ? void 0 : _resizeObserverRef_current.disconnect();
            resizeObserverRef.current = undefined;
            contentRef.current = null;
        };
    }, []);
    var contentCallback = useCallback(function(node) {
        if (node) {
            var _window = getWindowOrThrow();
            var observer = _window.ResizeObserver ? new _window.ResizeObserver(function(entry) {
                _window.requestAnimationFrame(function() {
                    var _entry_;
                    if (!entry) {
                        return;
                    }
                    var _entry__contentRect_height;
                    setHeaderHeight((_entry__contentRect_height = (_entry_ = entry[0]) === null || _entry_ === void 0 ? void 0 : _entry_.contentRect.height) !== null && _entry__contentRect_height !== void 0 ? _entry__contentRect_height : 0);
                });
            }) : undefined;
            observer === null || observer === void 0 ? void 0 : observer.observe(node);
            contentRef.current = node;
            setHeaderHeight(contentRef.current.clientHeight);
            if (observer) {
                resizeObserverRef.current = observer;
            }
        }
    }, [
        setHeaderHeight
    ]);
    return {
        contentCallback: contentCallback,
        contentRef: contentRef
    };
};
